import { render, staticRenderFns } from "./TopNavUndoRedo.vue?vue&type=template&id=148cf8ed&"
import script from "./TopNavUndoRedo.vue?vue&type=script&lang=ts&"
export * from "./TopNavUndoRedo.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavUndoRedo.vue?vue&type=style&index=0&id=148cf8ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports